/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Swiper from '../vendors/swiper-bundle.min';
import Owl from '../vendors/owl.carousel.min';
import './ajax-grant';
import './ajax-search-filter';
import './ajax-sidebar';
import './loadmore';
/**
 * Load More For Grant Template
 */

jQuery( window ).on( 'scroll', function() {
	const sc = jQuery( window ).scrollTop();
	if ( sc > 0 ) {
		jQuery( 'header' ).addClass( 'shrink' );
		jQuery( 'body' ).addClass( 'compress' );
	} else {
		jQuery( 'header' ).removeClass( 'shrink' );
		jQuery( 'body' ).removeClass( 'compress' );
	}
} );

jQuery( document ).ready( function() {
	jQuery( '#search-submit' ).on( 'click', function() {
		jQuery( this ).closest( 'form' ).submit();
	} );
	// When a year is clicked
	jQuery( '#post-year-option span' ).on( 'click', function() {
		const selectedYear = jQuery( this ).data( 'year' ); // Get the year from the clicked element
		const $hiddenInput = jQuery( 'input[name="search_year"]' ); // The hidden input for search_year
		$hiddenInput.val( selectedYear ); // Set the value of the hidden input to the selected year

		// Update the active class for the selected year
		jQuery( '#post-year-option span' ).removeClass( 'active' ); // Remove 'active' from all years
		jQuery( this ).addClass( 'active' ); // Add 'active' to the clicked year

		// Update the form action URL with the search_year query parameter
		const formAction = jQuery( '.hero__search--form form' ).attr( 'action' ); // Get the form action URL
		const urlParams = new URLSearchParams( window.location.search ); // Get existing URL parameters
		urlParams.set( 'search_year', selectedYear ); // Set or update the search_year parameter

		// Redirect to the new URL with the updated query parameters
		window.location.href = formAction + '?' + urlParams.toString();
	} );

	jQuery( '#clear-search-field' ).on( 'click', function() {
		jQuery( '#main_search' ).val( '' );
		jQuery( this ).closest( 'form' ).submit();
	} );

	let newspages = 2; // Start from page 2 since the first 9 posts are already loaded
	let news_total_pages = 0;
	if ( jQuery( '.load-more-news' ).length > 0 ) {
		const buttonData = jQuery( '.load-more-news' );
		const newspages = parseInt( buttonData.data( 'total-pages-news' ) );

		news_total_pages = newspages + 1;
	}

	jQuery( '.load-more-news' ).on( 'click', function( e ) {
		e.preventDefault();
		const button = jQuery( this ),
			newsContainer = jQuery( '.press-release__posts' ),
			loader = jQuery( '<div class="loader">Loading...</div>' );
			 const newBtn = '<a href="/category/press-releases/" class="button border-btn trp-btn">View All</a>';
		// Add loader animation
		button.html( loader );
		jQuery.ajax( {
			url: localVars.ajax_url, // AJAX handler URL (defined by WordPress)
			type: 'POST',
			data: {
				action: 'load_more_news',
				newspages,

			},
			success( response ) {
				if ( response ) {
					newsContainer.append( response );
					newspages++;
					button.html( 'Load More' );
				}
				if ( newspages === news_total_pages ) {
					button.replaceWith( newBtn );
				}
			},
		} );
	} );

	setTimeout( function() {
		const headerSec = jQuery( 'header' );
		const headerHeight = headerSec.outerHeight();
		const spacerSec = jQuery( '.s-64' );
		const heroPad = parseInt( jQuery( '.hero' ).css( 'padding-top' ) );
		const socialsTop = headerHeight + heroPad;
		const spacerHeight = spacerSec.outerHeight();
		const stickySec = jQuery( '.top-sticky' );
		const stickySecHeight = stickySec.outerHeight();
		const heightSum = headerHeight + stickySecHeight + spacerHeight;
		jQuery( '.page-template .socials__icons' ).css( 'top', socialsTop + 'px' );
		jQuery( '.page-template-template-research .socials__icons' ).css( 'top', heightSum + 'px' );
		if ( jQuery( window ).width() <= 747 ) {
			const col300Height = jQuery( '.one-column__text .col-300' ).outerHeight();
			const col840Height = jQuery( '.one-column__text .col-840 h2' ).outerHeight();
			const socialPos = socialsTop + col300Height + col840Height + 47;
			const totalSum = headerHeight + stickySecHeight + spacerHeight + col300Height + col840Height + 41;
			jQuery( '.page-template .socials__icons' ).css( 'top', socialPos + 'px' );
			jQuery( '.page-template-template-research .socials__icons' ).css( 'top', totalSum + 'px' );
			jQuery( 'body.hide-topbar.page-template-template-research .socials__icons' ).css( 'top', totalSum - 47 + 'px' );
		}
	}, 100 );
	const timelineHeight = jQuery( '.timeline__slide--inner' ).outerHeight();
	jQuery( '.timeline__content--bottom' ).css( 'margin-top', timelineHeight + 11 + 'px' );
	// Create a new div element
	if ( jQuery( window ).width() <= 747 ) {
		jQuery( '.table__inner' ).each( function() {
			let html = '';
			const tableHead = [];
			jQuery( this ).find( 'thead' ).find( 'th' ).each( function() {
				if ( jQuery( this ).text() != '' ) {
					tableHead.push( jQuery( this ).text() );
				}
			} );
			const columns = [];
			jQuery( this ).find( 'tbody' ).find( 'tr' ).each( function( ) {
				const column = [];
				jQuery( this ).find( 'td' ).each( function( ) {
					if ( jQuery( this ).text() != '' ) {
						column.push( jQuery( this ).text() );
					}
				} );
				columns.push( column );
			} );
			const columnsTrs = transpose( columns );
			for ( const key in columnsTrs ) {
				const element = columnsTrs[ key ];
				let tableRow = '';
				for ( const k in element ) {
					const el = element[ k ];
					tableRow += '<tr><td>' + el + '</td></tr>';
				}
				html += '<div class="table__item">';
				html += '<table>';
				html += '<thead><tr><th>' + tableHead[ key ] + '</th></tr></thead>';
				html += '<tbody>' + tableRow + '</tbody>';
				html += '</table>';
				html += '</div>';
			}
			jQuery( this ).html( html );
		} );
		function transpose( a ) {
			return Object.keys( a[ 0 ] ).map( function( c ) {
				return a.map( function( r ) {
					return r[ c ];
				} );
			} );
		}

		jQuery( '.table__inner' ).owlCarousel( {
			dots: false,
			items: 1,
			margin: 0,
			loop: false,
			nav: true,
		} );
	} else {
		jQuery( '.table__inner' ).each( function() {
			jQuery( this ).find( 'th' ).each( function() {
				if ( jQuery( this ).text() === '' ) {
					jQuery( this ).remove();
				}
			} );
			if ( jQuery( this ).find( 'th' ).length == 2 ) {
				jQuery( this ).find( 'th:first' ).attr( 'colspan', '1' );
				jQuery( this ).find( 'th:last' ).attr( 'colspan', '3' );
			}
			jQuery( this ).find( 'tr' ).each( function() {
				jQuery( this ).find( 'td' ).each( function() {
					if ( jQuery( this ).text() === '' ) {
						jQuery( this ).remove();
					}
				} );
				if ( jQuery( this ).find( 'td' ).length == 2 ) {
					jQuery( this ).find( 'td:first' ).attr( 'colspan', '1' );
					jQuery( this ).find( 'td:last' ).attr( 'colspan', '3' );
				}
			} );
		} );
	}

	/***
	 *
	 *
	 *
	 *  For View port
	 *
	 */
	jQuery(
		( function( jQuery, win ) {
			jQuery.fn.inViewport = function( cb ) {
				return this.each( function( i, el ) {
					function visPx() {
						const H = jQuery( this ).height(),
							r = el.getBoundingClientRect(),
							t = r.top,
							b = r.bottom;
						return cb.call(
							el,
							Math.max( 0, t > 0 ? H - t : b < H ? b : H )
						);
					}
					visPx();
					jQuery( win ).on( 'resize scroll', visPx );
				} );
			};
		} )( jQuery, window )
	);

	/***
	 *
	 *
	 *
	 *  Logo Slider
	 *
	 */
	jQuery( '.logos-slider__logos' ).slick( {
		arrows: false,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 7000,
		cssEase: 'linear',
		slidesToShow: 1,
		variableWidth: true,
		// pauseOnHover: true,
		responsive: [
			{
				breakpoint: 1440,
				settings: {
					slidesToShow: 6,
				},
			},
			{
				breakpoint: 1346,
				settings: {
					slidesToShow: 5,
				},
			},
			{
				breakpoint: 1181,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 748,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 420,
				settings: {
					slidesToShow: 1,
				},
			},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		],
	} );

	const owl = jQuery( '.stat__slider--items' );
	owl.owlCarousel( {
		loop: true,
		margin: 69,
		nav: false,
		dots: false,
		autoplay: true,
		items: 6,
		slideTransition: 'linear',
		autoplayTimeout: 4000,
		autoplaySpeed: 4000,
		mouseDrag: false,
		responsive: {
			0: {
				items: 1,
				stagePadding: 105,
			},
			600: {
				items: 2,
				stagePadding: 80,
			},
			1000: {
				items: 5,
				stagePadding: 60,
			},
			1440: {
				items: 6,
				stagePadding: 60,
			},
		},
	} );

	/***
	 *
	 *
	 *
	 *  Stats Counter
	 *
	 */

	// jQuery( '.stat__value' ).inViewport( function( px ) {
	// 	if ( px > 0 && ! this.initNumAnim ) {
	// 		this.initNumAnim = true;
	// 		const $this = jQuery( this ),
	// 			countTo = $this.attr( 'data-number' );
	// 		jQuery( {
	// 			countNum: $this.text(),
	// 		} ).animate(
	// 			{
	// 				countNum: countTo,
	// 			},
	// 			{
	// 				duration: 2500,
	// 				easing: 'swing',
	// 				step() {
	// 					// $this.text(Math.ceil(this.countNum));   showing commas during counter running
	// 					$this.text(
	// 						Math.ceil( this.countNum ).toLocaleString( 'en' )
	// 					);
	// 				},
	// 				complete() {
	// 					$this.text(
	// 						Math.ceil( this.countNum ).toLocaleString( 'en' )
	// 					);
	// 				},
	// 			}
	// 		);
	// 	}
	// } );

	/**
	 * Toggle menu for mobile
	 */
	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	// var $header_height = jQuery("header").outerHeight();
	// jQuery("body").css('padding-top', $header_height+'px');
	//  jQuery(window).resize(function() {
	// 	});

	// jQuery(window).trigger('resize');

	// jQuery(window).scroll(function(){
	// 	$header_height = jQuery("header").outerHeight();
	// 	jQuery("body").css('padding-top', $header_height+'px');
	// });

	jQuery( '.menu-btn' ).click( function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	// accessible sub menu
	jQuery( '.menu-item-has-children > a' ).focus( function() {
		jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
	  } ).blur( function() {
		jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
	  } );

	// For children
	  jQuery( '.sub-menu a' ).focus( function() {
		jQuery( this ).parents( '.sub-menu' ).addClass( 'focused' );
	  } ).blur( function() {
		jQuery( this ).parents( '.sub-menu' ).removeClass( 'focused' );
	  } );
	jQuery.noConflict();
	jQuery( '.search-popup-ctn' ).focus( function() {

	} );
	// jQuery( '.search-popup-ctn' ).focus( function() {
	// 	jQuery( '.search-popup' ).addClass( 'focused' );
	//   } ).blur( function() {
	// 	jQuery( '.search-popup' ).removeClass( 'focused' );
	//   } );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );
	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */
	jQuery( '.header-nav .submenu-icon' ).click( function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	/**
	 * One page menu
	 */

	const liClicked = false;
	const navID = '#TopNav'; //Pass here the ID of navigation
	jQuery( window ).scroll( function() {
		const y = jQuery( this ).scrollTop();
		const top = jQuery( window ).scrollTop();
		const body = jQuery( 'html, body' );
		jQuery( navID + ' li[id]' ).each( function() {
			const id = jQuery( this ).attr( 'id' );
			const viewPort = jQuery( '.' + id ).offset().top - 200;
			if ( y >= viewPort ) {
				if ( ! liClicked ) {
					jQuery( navID + ' li' )
						.not( this )
						.removeClass( 'active' );
					jQuery( this ).addClass( 'active' );
				}
			}
		} );
	} );

	jQuery( navID + ' li' ).click( function() {
		const attr = jQuery( this ).attr( 'id' );
		const divPosition = jQuery( '.' + attr ).offset();
		if ( attr ) {
			jQuery( 'html, body' ).animate(
				{
					scrollTop: divPosition.top - 130,
				},
				500
			);
			jQuery( navID + ' li' ).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
		}
		return false;
	} );
	jQuery( '#scroll-indicator a, .footer-share a' ).bind(
		'click',
		function( event ) {
			const $anchor = jQuery( this );

			jQuery( 'html, body' )
				.stop()
				.animate(
					{
						scrollTop: jQuery( $anchor.attr( 'href' ) ).offset().top,
					},
					500
				);
			/*
		if you don't want to use the easing effects:*/
			event.preventDefault();
		}
	);

	/**
	 * Search Popup
	 */

	jQuery( '.header-btns a, .mobile-button a' ).on( 'click', function() {
		jQuery( '.need-help-container' ).addClass( 'show' );
	} );

	jQuery( '.need-help-close a' ).on( 'click', function() {
		jQuery( '.need-help-container, .need-help-questions' ).removeClass(
			'show'
		);
	} );
	jQuery( '.need-help-back a' ).on( 'click', function() {} );

	jQuery(
		'a.video-image, .story__slide--img.has-video , .has-video .post-box__icon'
	).magnificPopup( {
		type: 'iframe',
	} );

	/*
	 *
	 *	* Close dropdown on outside click
	 *
	 * */

	jQuery( '.select-dropdown__button' ).on( 'click', function() {
		const dropdown = jQuery( this ).closest( '.select-dropdown' );
		dropdown
			.find( '.select-dropdown__button' )
			.toggleClass( 'is-button-opened' );
		dropdown
			.find( '.select-dropdown__list' )
			.toggleClass( 'is-active-dropdown' );
	} );

	/*
	 *
	 *	* Dropdown Close Funcatonality
	 *
	 * */
	if ( jQuery( '.timeline__slider' ).length > 0 ) {
		new Swiper( '.timeline__slider', {
			slidesPerView: 'auto',
			spaceBetween: 0,
			freeMode: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				500: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		} );
	}

	jQuery( '.story__sync-slider--two .slick-slide.slick-current' ).prev().addClass( 'prev' );
	jQuery( '.cross-btn' ).on( 'click', function() {
		jQuery( this )
			.parents( '.select-dropdown__list' )
			.removeClass( 'is-active-dropdown' );
	} );

	jQuery( '.select-dropdown__sort-item' ).on( 'click', function() {
		const ratioText = 'Ratio';
		const itemValue = jQuery( this )
			.children()
			.find( '.select-dropdown__inner-title' )
			.data( ratioText );
		jQuery( this )
			.addClass( 'active-list' )
			.siblings()
			.removeClass( 'active-list' );
		jQuery( this )
			.parents( '.select-dropdown' )
			.find( '.select-dropdown__button span.dd-selected-value' )
			.text( jQuery( this ).text() )
			.parents()
			.attr( 'data-value', itemValue );
		jQuery( this )
			.parents( '.select-dropdown' )
			.find( '.select-dropdown__list' )
			.removeClass( 'is-active-dropdown' );
		jQuery( this )
			.parents( '.select-dropdown' )
			.find( '.select-dropdown__button.is-button-opened' )
			.removeClass( 'is-button-opened' );
	} );

	function setCheckboxSelectLabels( elem ) {
		const wrappers = jQuery( '.grant-filter__select--inner' );
		jQuery.each( wrappers, function( key, wrapper ) {
			const checkboxes = jQuery( wrapper ).find( '.ckkBox' );
			const label = jQuery( wrapper ).find( '.checkboxes' ).attr( 'id' );
			let prevText = '';
			jQuery.each( checkboxes, function( i, checkbox ) {
				const button = jQuery( wrapper ).find( 'button' );
				if ( jQuery( checkbox ).prop( 'checked' ) == true ) {
					const text = jQuery( checkbox ).next().html();
					let btnText = prevText + text;
					const numberOfChecked = jQuery( wrapper ).find(
						'input.val:checkbox:checked'
					).length;
					if ( numberOfChecked >= 4 ) {
						btnText = numberOfChecked + ' ' + label + ' selected';
					}
					jQuery( button ).text( btnText );
					prevText = btnText + ', ';
				}
			} );
		} );
	}

	function toggleCheckedAll( checkbox ) {
		const apply = jQuery( checkbox )
			.closest( '.grant-filter__select--inner' )
			.find( '.apply-selection' );
		apply.fadeIn( 'slow' );

		// eslint-disable-next-line @wordpress/no-unused-vars-before-return
		const val = jQuery( checkbox ).closest( '.checkboxes' ).find( '.val' );
		const all = jQuery( checkbox ).closest( '.checkboxes' ).find( '.all' );
		const ckkBox = jQuery( checkbox ).closest( '.checkboxes' ).find( '.ckkBox' );

		if ( ! jQuery( ckkBox ).is( ':checked' ) ) {
			jQuery( all ).prop( 'checked', true );
			return;
		}

		if ( jQuery( checkbox ).hasClass( 'all' ) ) {
			jQuery( val ).prop( 'checked', false );
		} else {
			jQuery( all ).prop( 'checked', false );
		}
	}

	jQuery( '.gallery__slides' ).owlCarousel( {
		margin: 20,
		items: 3,
		dots: false,
		nav: true,
		responsive: {
			0: {
				items: 1,
				stagePadding: 41,
			},
			600: {
				items: 2,
				stagePadding: 48,
			},
			1000: {
				items: 3,
			},
		},
	} );
	jQuery( '.news-posts-slider .news-post__items' ).owlCarousel( {
		margin: 21,
		items: 2,
		dots: false,
		autoHeight: true,
		stagePadding: '30',
		nav: true,
		responsive: {
			0: {
				items: 1,
				stagePadding: '22.5',
				margin: 18,
			},
			600: {
				items: 2,
			},
			1000: {
				items: 2,
			},
		},
	} );

	jQuery( '.advances-search' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).removeClass( 'active' );
			jQuery( '.grant-filter__select-area' ).slideUp();
		} else {
			jQuery( '.advances-search' ).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
			jQuery( '.grant-filter__select-area' ).slideUp();

			jQuery( this ).addClass( 'active' );
			jQuery( '.grant-filter__select-area' ).slideDown();
		}
	} );

	jQuery(
		'.search-filter__select--head,.toggle-next,.select-dropdown__button,.jump-links__menu--title'
	).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).removeClass( 'active' );
			jQuery( this )
				.siblings(
					'.search-filter__select--body,.checkboxes,.select-dropdown__list,#TopNav'
				)
				.slideUp();
		} else {
			jQuery(
				'.search-filter__select--head,.toggle-next,.select-dropdown__button,.jump-links__menu--title'
			).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
			jQuery(
				'.search-filter__select--body,.checkboxes,.select-dropdown__list,#TopNav'
			).slideUp();

			jQuery( this ).addClass( 'active' );
			jQuery( this )
				.siblings(
					'.search-filter__select--body,.checkboxes,.select-dropdown__list,#TopNav'
				).slideDown();
		}
	} );
	jQuery( '.search-filter__select--item  ul li span' ).on( 'click', function() {
		const selectedText = jQuery( this ).text();
		const targetText = jQuery( this )
			.closest( '.dropdown' )
			.children( '.search-filter__select--head' );
		// const targetType = jQuery( this )
		// 	.closest( '.dropdown' )
		// 	.children( '.hidden-field' );
		targetText.text( selectedText );
		// targetType.val( selectedText );
	} );
	jQuery( '.search-filter__select--item  ul li span' ).on( 'click', function() {
		jQuery( this ).closest( '.search-filter__select--body' ).slideUp();
		const titleHeadClose = jQuery( this )
			.closest( '.dropdown' )
			.children( '.search-filter__select--head' );
		titleHeadClose.removeClass( 'active' );
	} );
	jQuery( '.select-dropdown__sort-item' ).on( 'click', function() {
		jQuery( this ).closest( '.select-dropdown__list' ).slideUp();
		jQuery( this ).closest( '.select-dropdown__list' ).siblings( '.select-dropdown__button' ).removeClass( 'active' );
		jQuery( this ).closest( '.select-dropdown__list' ).removeClass( 'active' );
	} );

	jQuery.noConflict();
	jQuery( '.search-popup__icon' ).on( 'click', function() {
		jQuery( '.search-popup__form' ).addClass( 'show' );
	} );
	jQuery( '.search-popup__close' ).on( 'click', function() {
		jQuery( '.search-popup__form' ).removeClass( 'show' );
	} );

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.jump-links__items ul li' ).on( 'click', function() {
			const currentMenuLink = jQuery( this ).text();
			jQuery( '.jump-links__menu--title' ).text( currentMenuLink );
			jQuery( '.jump-links__items' ).removeClass( 'active' );
		} );//  // jQuery( this ).parents( '.dropdown-at-mobile' ).removeClass( 'active' );
	}
	jQuery( '.hero__arrow' ).click( function( e ) {
		e.preventDefault();
		const target = jQuery( jQuery( this ).attr( 'href' ) );
		if ( target.length ) {
			const scrollTo = target.offset().top;
			jQuery( 'body, html' ).animate( { scrollTop: scrollTo + 'px' }, 600 );
		}
	} );
} );
jQuery( document ).ready( function() {
	// Function to set height of items based on the tallest content and color bar
	function setTimelineItemHeight() {
		let tHeight = 0;
		let bHeight = 0;

		// Loop through each timeline slide
		jQuery( '.timeline__slide' ).each( function() {
			const topContentHeight = jQuery( this ).find( '.timeline__content--top .timeline__content--inner' ).outerHeight();
			const bottomContentHeight = jQuery( this ).find( '.timeline__content--bottom .timeline__content--inner' ).outerHeight();

			// Calculate total height of content and color bar
			const topHeight = topContentHeight;
			const bottomHeight = bottomContentHeight;

			// Update maxHeight if totalHeight is greater
			if ( topHeight > tHeight ) {
				tHeight = topHeight;
			}
			if ( bottomHeight > bHeight ) {
				bHeight = bottomHeight;
			}
		} );

		// Set the height of all timeline items to the maximum height
		jQuery( '.timeline__content--top .timeline__content--inner' ).height( tHeight );
		jQuery( '.timeline__content--bottom .timeline__content--inner' ).height( bHeight );
	}

	// Call the function on page load
	setTimelineItemHeight();

	// Recalculate height when window is resized
	jQuery( window ).resize( function() {
		setTimelineItemHeight();
	} );
} );

jQuery( document ).ready( function() {
	const keys = {
		ESC: 27,
		TAB: 9,
		RETURN: 13,
		SPACE: 32,
		LEFT: 37,
		UP: 38,
		RIGHT: 39,
		DOWN: 40,
	};
	jQuery( '.dropdown-menu' ).hide();
	jQuery( '#dropdownMenu1' ).on( 'click', function( event ) {
		jQuery( '.dropdown-menu' ).toggle( function() {
				  if ( jQuery( '.dropdown-menu' ).is( ':visible' ) ) {
				jQuery( '#dropdownMenu1' ).attr( 'aria-expanded', 'true' );
				jQuery( '.dropdown-menu' ).focus();
				  }
				  } );
	} );
	jQuery( '.dropdown-menu' ).on( 'keydown', function( event ) {
		doKeypress( keys, event );
	} );
		    jQuery( '.dropdown-menu' ).on( 'click', 'button', function( event ) {
		selectOption( jQuery( this ) );
	} );
} );

function doKeypress( keys, event ) {
	const current = jQuery( ':focus' );
	current.addClass( 'highlight' );
	 let highligted = jQuery( ':focus' );

	switch ( event.which ) {
		case keys.ESC:
			jQuery( '.dropdown-menu' ).hide();
				 jQuery( '#dropdownMenu1' ).focus();
			break;

		case keys.TAB:
			  if ( current.hasClass( 'last' ) ) {
				if ( event.shiftKey ) {
					current.removeClass( 'highlight' ).prev( 'button' ).addClass( 'highlight' ).focus();
				} else {
					jQuery( '#dropdownMenu1' ).attr( 'aria-expanded', 'false' );
					jQuery( '.dropdown-menu' ).hide();
					jQuery( '*' ).removeClass( 'highlight' );
				}
			  }
				 if ( event.shiftKey ) {
				 current.removeClass( 'highlight' ).prev( 'button' ).addClass( 'highlight' ).focus();
				 } else {
				 current.removeClass( 'highlight' ).next( 'button' ).addClass( 'highlight' ).focus();
			}
				 break;

		case keys.UP:
			event.preventDefault();
			event.stopPropagation();
			return moveUp( highligted );
			break;

		case keys.DOWN:

			event.preventDefault();
			event.stopPropagation();
			return moveDown( highligted );
			break;

		case keys.RETURN:
			highligted = jQuery( '.highlight' );
			if ( highligted ) {
				if ( highligted.attr( 'id' ) == 'dropdown-menu' ) {
					return false;
				}

				event.preventDefault();
				event.stopPropagation();
				return selectOption( highligted );

				break;
			}
		case keys.SPACE:
				      highligted = jQuery( '.highlight' );
				      if ( highligted ) {
				if ( highligted.attr( 'id' ) == 'dropdown-menu' ) {
					return false;
				}

				event.preventDefault();
				event.stopPropagation();
				return selectOption( highligted );

				break;
			}
		default:
	}
}

function selectOption( highligted ) {
	if ( highligted ) {
			 highligted.attr( 'aria-selected', true );
		jQuery( '#dropdownMenu1' ).html( highligted.text() );
			  jQuery( '#dropdownMenu1' ).attr( 'aria-label', 'Current company: ' + jQuery( highligted ).text() + '.' );
		jQuery( '#dropdownMenu1' ).focus();
		jQuery( '#dropdownMenu1' ).attr( 'aria-expanded', 'false' );
		jQuery( '.dropdown-menu' ).hide();
			  jQuery( '*' ).removeClass( 'highlight' );
	} else {

	}
}
function moveDown( highligted ) {
	highligted = jQuery( ':focus' );
			  if ( highligted.attr( 'id' ) == 'dropdown-menu' ) {
		highligted.removeClass( 'highlight' );
		highligted.children().first( 'li' ).children( 'button' ).addClass( 'highlight' ).focus();
			  } else {
			  highligted.removeClass( 'highlight' ).parent().next( 'li' ).children( 'button' ).addClass( 'highlight' ).focus();
			  }
}
function moveUp( highligted ) {
	highligted = jQuery( ':focus' );
			  if ( highligted.attr( 'id' ) == 'dropdown-menu' ) {
		highligted.removeClass( 'highlight' );
			  } else {
			  highligted.removeClass( 'highlight' ).parent().prev( 'li' ).children( 'button' ).addClass( 'highlight' ).focus();
			  }
}
